/** The row box every panel row shares; rows that can't be a `HoverNavRow` reuse it. */
export const PANEL_ROW_CLASS =
  'flex min-h-8 w-full min-w-0 items-center gap-2 rounded-lg px-2 py-1 text-left text-lg transition-colors';

/** Favourite ids are panel-scoped, so the section id keeps two sections' row ids apart. */
export function favouriteId(...parts: string[]): string {
  return parts.join('/');
}
